import { EVENT_CALENDAR_URL } from '@/constants/calendar';
import { useNavigate } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import SearchModule from './searchModule/SearchModule';
import SearchResults from './searchResults/SearchResults';
import { IoCloseSharp } from 'react-icons/io5';

const Search = () => {
  const navigate = useNavigate();

  const CloseBtnClick = () => {
    navigate(EVENT_CALENDAR_URL);
  };

  return (
    <main
      className={`relative h-full mx-auto pt-16 box-border flex flex-col gap-4 overflow-y-auto overflow-x-hidden ${
        isMobile ? 'w-[90%]' : 'w-[80%]'
      }`}
    >
      {isMobile ? (
        <IoCloseSharp
          cursor={'pointer'}
          className='absolute top-4 right-[-5px]'
          size={'2rem'}
          onClick={CloseBtnClick}
        />
      ) : (
        <IoCloseSharp
          cursor={'pointer'}
          size={'2rem'}
          onClick={CloseBtnClick}
        />
      )}
      <SearchModule />
      <SearchResults />
    </main>
  );
};

export default Search;
